import api from './api';

// --- Data Structures ---
export interface User {
    id: number;
    username: string;
    macc: string;
    maKK: number;
    employeeName: string;
    departmentName: string;
    createdAt: string;
    permissions: string[];
    permissionIds: number[];
}

export interface Permission {
    permissionId: number;
    name: string;
    description: string;
}

export interface Employee {
    macc: string;
    tennv: string;
    tenKK: string;
    mahis?: number;
    nghiviec: boolean;
}

export interface CreateUserRequest {
    username: string;
    password?: string;
    macc: string;
    permissionIds: number[];
}

export interface UpdateUserRequest {
    password?: string;
    macc: string;
    permissionIds: number[];
}

// --- API Service ---
export const userService = {
    async getUsers(): Promise<User[]> {
        const response = await api.get('/user');
        return response.data;
    },

    async getUserById(id: number): Promise<User> {
        const response = await api.get(`/user/${id}`);
        return response.data;
    },

    async createUser(data: CreateUserRequest): Promise<User> {
        const response = await api.post('/user', data);
        return response.data;
    },

    async updateUser(id: number, data: UpdateUserRequest): Promise<void> {
        await api.put(`/user/${id}`, data);
    },

    async deleteUser(id: number): Promise<void> {
        await api.delete(`/user/${id}`);
    },

    async getPermissions(): Promise<Permission[]> {
        const response = await api.get('/user/permissions');
        return response.data;
    },

    async getUnassignedEmployees(): Promise<Employee[]> {
        const response = await api.get('/user/employees/unassigned');
        return response.data;
    }
};
